const getImage = (images, imagePreview, isDesktop, index = 0) => {
  if (!images) {
    if (imagePreview) {
      return imagePreview;
    }

    return null;
  }

  const fileName = images?.file_names[index]; // eslint-disable-line camelcase
  if (!fileName) {
    return null;
  }

  const imagesByAspectRatios = images.urls[fileName];
  let idealImage;

  if (imagesByAspectRatios['16:9'] && isDesktop) {
    if (imagesByAspectRatios['16:9']['400']) {
      idealImage = imagesByAspectRatios['16:9']['400'];
    }
  } else if (imagesByAspectRatios['4:3'] && !isDesktop) {
    if (imagesByAspectRatios['4:3']['400']) {
      idealImage = imagesByAspectRatios['4:3']['400'];
    }
  } else if (imagesByAspectRatios['1:1']) {
    if (imagesByAspectRatios['1:1']['400']) {
      idealImage = imagesByAspectRatios['1:1']['400'];
    }
  }

  if (!idealImage) {
    // take what you can get
    const firstAvailableRatio = Object.keys(imagesByAspectRatios)[0];
    const firstAvailableDimension = Object.keys(imagesByAspectRatios[firstAvailableRatio])[0];
    const firstAvailableImage = imagesByAspectRatios[firstAvailableRatio][firstAvailableDimension];
    idealImage = firstAvailableImage;
  }

  return idealImage;
};

export default getImage;
